import { SectionHeading } from "./SectionHeading";
import { VideoEmbed } from "./VideoEmbed";
import { Reveal } from "./Reveal";

export const VslSection = () => (
  <section id="vsl" className="bg-[#080808] py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-6 lg:px-8">
      <SectionHeading
        eyebrow="Il video di presentazione"
        title="Scopri perché è nato Tempio Vivo."
        subtitle="Guarda il video e scopri come trasformare la tua fede in azioni concrete."
        testid="vsl-heading"
      />
      <Reveal className="mx-auto max-w-4xl">
        <VideoEmbed
          videoId="qpD83Ap_ra4"
          title="Scopri perché è nato Tempio Vivo — VSL ufficiale"
          testid="vsl-player"
        />
      </Reveal>
      <Reveal className="mt-12 text-center">
        <p className="mb-6 text-sm font-semibold uppercase tracking-[0.2em] text-[#B8B8B8]">
          Hai scoperto Tempio Vivo. Ora scegli come iniziare.
        </p>
        <a
          data-testid="vsl-discover-paths-button"
          href="#offerte"
          className="inline-flex items-center justify-center rounded-sm bg-[#C9A45C] px-8 py-4 text-xs font-bold uppercase tracking-widest text-[#080808] transition-colors duration-300 hover:bg-[#E8D5A3] sm:text-sm"
        >
          Scopri i due percorsi
        </a>
      </Reveal>
    </div>
  </section>
);
